import React from 'react';
import {
  makeStyles,
  Theme,
  createStyles,
  IconButton,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { Quest } from '../QuestModal';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    titleCell: {
      cursor: 'pointer',
      color: theme.palette.primary.main,
      '&:hover': {
        textDecoration: 'underline',
      },
    },

    deleteButton: {
      color: theme.palette.error.main,
    },
  })
);

type Props = {
  quests: Quest[];
  onEditQuest: (quest: Quest) => void;
  onDeleteQuest: (quest: Quest) => void;
};

export const QuestsTable = ({ quests, onEditQuest, onDeleteQuest }: Props) => {
  const classes = useStyles();

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Заголовок</TableCell>
          <TableCell>Вознаграждение</TableCell>
          <TableCell align="right">Удалить</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {quests.map((quest) => (
          <TableRow key={quest.id} hover>
            <TableCell className={classes.titleCell} onClick={() => onEditQuest(quest)}>
              {quest.title}
            </TableCell>
            <TableCell>{quest.rewardAmount}</TableCell>
            <TableCell align="right">
              <IconButton
                size="small"
                className={classes.deleteButton}
                onClick={() => onDeleteQuest(quest)}
              >
                <DeleteIcon />
              </IconButton>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
